import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { showPartnerLogos } from "@/config/site";

const partners = [
  { name: "Copenhagen", src: "/assets/cph.png" },
  { name: "MS Konsulent", src: "/assets/mskonsulent.png" },
  { name: "Soul Performance", src: "/assets/soulperformance.png" },
  { name: "Auta", src: "/assets/auta.png" },
];

const PartnerStrip = () => {
  const { t } = useLang();
  // Hidden until written display consent from each partner is documented.
  if (!showPartnerLogos) return null;
  return (
    <section className="bg-[#F7F5F0] border-y border-black/5" data-testid="partner-strip">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <Reveal>
          <p className="text-center text-xs uppercase tracking-[0.3em] text-[#5C7567] mb-10">{t.common.partners}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex flex-wrap items-center justify-center gap-x-14 gap-y-8">
            {partners.map((p) => (
              <img
                key={p.name}
                src={p.src}
                alt={p.name}
                className="h-10 sm:h-12 w-auto object-contain opacity-60 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-500"
                data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default PartnerStrip;
